import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";
import Index from "./index";
import Edit from "./edit";

export default class Base extends Component {
    render() {
        return (
                <Switch>
                    <Route exact path="/showcases" component={Index}/>
                    <Route path="/showcases/create" component={Edit}/>
                    <Route path="/showcases/:id" component={Edit}/>
                </Switch>
        )
    }
}
